var getHexColor = function (color) {
    var context = document.createElement('canvas').getContext('2d');
    context.fillStyle = color;
    return context.fillStyle;
};
export default getHexColor;
//# sourceMappingURL=getHexColor.js.map